import { ArrowRight } from "lucide-react";
import { brands } from "../mock";

const Hero = ({ onSignup }) => {
  return (
    <>
      <section className="ws-hero">
        <div className="hero-grid hero-grid-left">
          <span className="hero-grid-cell" style={{ top: 44, left: 88, animationDelay: "0s" }} />
          <span className="hero-grid-cell" style={{ top: 132, left: 132, animationDelay: "1.1s" }} />
          <span className="hero-grid-cell" style={{ top: 88, left: 176, animationDelay: "2.2s" }} />
        </div>
        <div className="hero-grid hero-grid-right">
          <span className="hero-grid-cell" style={{ top: 88, left: 88, animationDelay: "0.6s" }} />
          <span className="hero-grid-cell" style={{ top: 176, left: 44, animationDelay: "1.7s" }} />
          <span className="hero-grid-cell" style={{ top: 132, left: 176, animationDelay: "2.8s" }} />
        </div>
        <h1>Uw partner in wereldwijde elektronicadistributie</h1>
        <p>
          WS Global Trading verbindt merken, retailers en groothandels via een
          betrouwbaar netwerk van sourcing en distributie. Altijd scherpe
          voorwaarden, altijd op voorraad.
        </p>
        <div className="ws-hero-actions">
          <button className="ws-btn ws-btn-lime" onClick={onSignup}>
            Vraag account aan <ArrowRight size={17} className="arrow-icon" />
          </button>
          <button className="ws-btn ws-btn-dark" onClick={onSignup}>
            Account aanmaken <ArrowRight size={17} className="arrow-icon" />
          </button>
        </div>
      </section>

      <section className="ws-brands">
        <div className="ws-brands-label">Wereldwijde A-merken waar wij mee werken</div>
        <div className="marquee">
          <div className="marquee-track">
            {[...brands, ...brands, ...brands].map((brand, i) => (
              <img key={i} src={brand.logo} alt={brand.name} loading="lazy" />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
